import React, { useState, useEffect } from "react";

export const navigate = (path) => {
  if (window.location.pathname === path) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
};

export const Link = ({ to, children, ...rest }) => (
  <a
    href={to}
    onClick={(e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (rest.target) return;
      e.preventDefault();
      navigate(to);
    }}
    {...rest}
  >
    {children}
  </a>
);

export const usePath = () => {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  return path;
};
